import Utils from 'common/utils';
import BlankScss from './BlankPage.module.scss';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  img: string;
  errorCode: string;
  title: string;
  desc: string;
}

/**
 * Error 相关，空白展示页，统一样式
 */
const ErrorBlankPage: React.FC<IProps> = (props: IProps) => {
  const { className, style, errorCode, img, desc, title } = props;
  return (
    <div className={Utils.uniteClass(BlankScss.notFound, className)} style={style}>
      <div className={BlankScss.content}>
        <img src={img} alt={errorCode} />
        <p className={BlankScss.title}>{title}</p>
        <p className={BlankScss.desc}>{desc}</p>
      </div>
    </div>
  );
};

export default React.memo(ErrorBlankPage);
